import React from 'react';

import SearchNav from '../components/Search/SearchNav';
import {useHref, useNavigate} from '../util/react-router-v6-shim';
import {AppTree} from './AppTree';

const GLOBAL_HEADER = <SearchNav />;

export const AppWithRoutes = () => {
  const navigate = useNavigate();

  return (
    <AppTree navigate={navigate} useHref={useHref} header={GLOBAL_HEADER} />
  );
};
